import type { ExcelColumnMapping } from './types';
import { formatDate } from '@/lib/formatUtils';
import { STATUS_MAP } from './constant';

export const HOA_DON_MUA_DICH_VU_COLUMNS: ExcelColumnMapping[] = [
  {
    header: 'Trạng thái',
    width: 16,
    resolver: row => STATUS_MAP[row?.status] || row?.status || ''
  },
  {
    header: 'Số c/từ',
    width: 18,
    resolver: row => row?.so_ct || ''
  },
  {
    header: 'Ngày c/từ',
    width: 16,
    resolver: row => formatDate(row?.ngay_ct)
  },
  {
    header: 'Số hóa đơn',
    width: 16,
    resolver: row => row?.so_ct0 || ''
  },
  {
    header: 'Mã nhà cung cấp',
    width: 20,
    resolver: row => row?.ma_kh_data?.customer_code || row?.ma_kh || ''
  },
  {
    header: 'Tên nhà cung cấp',
    width: 28,
    resolver: row => row?.ma_kh_data?.customer_name || row?.ten_kh_thue || ''
  },
  {
    header: 'Diễn giải',
    width: 40,
    resolver: row => row?.dien_giai || ''
  },
  {
    header: 'Tk có',
    width: 12,
    resolver: row => row?.tk_data?.code || row?.tk || ''
  },
  {
    header: 'Tổng tiền',
    width: 18,
    resolver: row => Number(row?.t_tt_nt || row?.t_tt || '')
  },
  {
    header: 'Ngoại tệ',
    width: 12,
    resolver: row => row?.ma_nt_data?.ma_nt || row?.ma_nt || ''
  }
];
